import { OrganisationsRemoteDto } from '../../../../../generated/swagger';
import { LongRunningAction } from '../../../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';

export class DirectoryOrganisationsLoaded {
   public static readonly type = '[DirectoryOrganisationData] directory organisations loaded';

   constructor(public organisationsData: OrganisationsRemoteDto) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.DIRECTORY_SEARCH)
export class LoadDirectoryOrganisations {
   public static readonly type = '[DirectoryOrganisationData] load directory organisations';

   constructor() {}
}
